// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackupPage_page__wHyZQ {
  padding: 20px 26px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* === Header === */
.BackupPage_header__8aMls h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  color: #222;
  display: flex;
  align-items: center;
  gap: 8px;
}

.BackupPage_header__8aMls p {
  margin: 2px 0 0;
  color: #555;
  font-size: 14px;
}

/* === Main Content === */
.BackupPage_main__SLRQi {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* === Card === */
.BackupPage_card__7CuOB {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  padding: 18px 20px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.BackupPage_card__7CuOB h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #222;
  display: flex;
  align-items: center;
  gap: 6px;
}

.BackupPage_card__7CuOB p {
  margin: 0;
  font-size: 14px;
  color: #444;
  line-height: 1.4;
}

/* === Controls (Год, месяц, кнопка) === */
.BackupPage_controls__IAPKu {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.BackupPage_controls__IAPKu label {
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 6px;
}

.BackupPage_controls__IAPKu select {
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid #cbd3e1;
  background: #fff;
  font-size: 14px;
  min-width: 110px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.BackupPage_controls__IAPKu select:hover {
  border-color: #9aa4b2;
}

.BackupPage_backupBtn__796V2 {
  background: #3f51b5;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.BackupPage_backupBtn__796V2:hover {
  background: #303f9f;
}

.BackupPage_backupBtn__796V2:disabled {
  opacity: 0.6;
  cursor: default;
}

/* === Result Block === */
.BackupPage_result__OnFRF {
  margin-top: 8px;
  padding: 12px 14px;
  background: #f7f9fc;
  border: 1px solid #d8e1f1;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
}

.BackupPage_success__Yn9Ma {
  color: #2e7d32;
  font-weight: 600;
}

.BackupPage_error__JwN73 {
  color: #c62828;
  font-weight: 600;
}

/* === File List === */
.BackupPage_filesList__pqzr3 {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 200px;
  overflow-y: auto;
}

.BackupPage_fileItem__9wg4- {
  padding: 6px 8px;
  background: #fff;
  border: 1px solid #e3e8f0;
  border-radius: 6px;
  font-size: 13px;
  color: #444;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Scrollbar */
.BackupPage_filesList__pqzr3::-webkit-scrollbar {
  width: 6px;
}
.BackupPage_filesList__pqzr3::-webkit-scrollbar-thumb {
  background: #c1c7d4;
  border-radius: 6px;
}
.BackupPage_filesList__pqzr3::-webkit-scrollbar-thumb:hover {
  background: #a6adbd;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/Backup/BackupPage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".page {\r\n  padding: 20px 26px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* === Header === */\r\n.header h1 {\r\n  margin: 0;\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  color: #222;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.header p {\r\n  margin: 2px 0 0;\r\n  color: #555;\r\n  font-size: 14px;\r\n}\r\n\r\n/* === Main Content === */\r\n.main {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* === Card === */\r\n.card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\r\n  padding: 18px 20px;\r\n  max-width: 600px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.card h3 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  color: #222;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.card p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #444;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* === Controls (Год, месяц, кнопка) === */\r\n.controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-top: 4px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.controls label {\r\n  font-size: 14px;\r\n  color: #333;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.controls select {\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid #cbd3e1;\r\n  background: #fff;\r\n  font-size: 14px;\r\n  min-width: 110px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.controls select:hover {\r\n  border-color: #9aa4b2;\r\n}\r\n\r\n.backupBtn {\r\n  background: #3f51b5;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 8px 14px;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.backupBtn:hover {\r\n  background: #303f9f;\r\n}\r\n\r\n.backupBtn:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n\r\n/* === Result Block === */\r\n.result {\r\n  margin-top: 8px;\r\n  padding: 12px 14px;\r\n  background: #f7f9fc;\r\n  border: 1px solid #d8e1f1;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.success {\r\n  color: #2e7d32;\r\n  font-weight: 600;\r\n}\r\n\r\n.error {\r\n  color: #c62828;\r\n  font-weight: 600;\r\n}\r\n\r\n/* === File List === */\r\n.filesList {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.fileItem {\r\n  padding: 6px 8px;\r\n  background: #fff;\r\n  border: 1px solid #e3e8f0;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  color: #444;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n/* Scrollbar */\r\n.filesList::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n.filesList::-webkit-scrollbar-thumb {\r\n  background: #c1c7d4;\r\n  border-radius: 6px;\r\n}\r\n.filesList::-webkit-scrollbar-thumb:hover {\r\n  background: #a6adbd;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `BackupPage_page__wHyZQ`,
	"header": `BackupPage_header__8aMls`,
	"main": `BackupPage_main__SLRQi`,
	"card": `BackupPage_card__7CuOB`,
	"controls": `BackupPage_controls__IAPKu`,
	"backupBtn": `BackupPage_backupBtn__796V2`,
	"result": `BackupPage_result__OnFRF`,
	"success": `BackupPage_success__Yn9Ma`,
	"error": `BackupPage_error__JwN73`,
	"filesList": `BackupPage_filesList__pqzr3`,
	"fileItem": `BackupPage_fileItem__9wg4-`
};
export default ___CSS_LOADER_EXPORT___;
